import { BackdropClassKey } from '@material-ui/core/Backdrop';
import { Theme, alpha } from '@material-ui/core/styles';

const MuiBackdrop = (theme: Theme): Partial<Record<BackdropClassKey, unknown>> => ({
    root: {
        backgroundColor: alpha(theme.palette.grey[600], 0.8),
    },
});

export default MuiBackdrop;
